import { api } from 'api/api'
import { dashboardSchema } from '../getDashboard'

export const getDefaultDeviceDashboard = async (deviceId: string) => {
  const data = await api
    .get(`/v1/dashboards/devices/${deviceId}/default`)
    .then(({ data }) => dashboardSchema.parse(data))

  if (data.id === '00000000-0000-0000-0000-000000000000')
    throw new Error('No default dashboard specified')

  return data
}
